const showPrivacySettings = () => window?.ketch && window.ketch('showExperience', { displayHint: 'experiences.consent.modal' });

export const menuItems = [
	{
		children: [
			{
				label: "News",
				link: "https://www.instantscripts.com.au/blog",
			},
			{
				label: "In the media",
				link: "https://www.instantscripts.com.au/media_release",
			},
			{
				label: "Pricing",
				link: "/pricing",
			},
			{
				label: "Our story",
				link: "/about-us",
			},
			{
				label: "Privacy T&C",
				link: "/privacy-policy",
			},
			{
				label: "Privacy Settings",
				onClick: () => showPrivacySettings(),
			},
			{
				label: "Customer T&C",
				link: "/customer-terms-and-conditions",
			},
			{
				label: "Platform T&C",
				link: "/platform-terms-and-conditions",
			},
			{
				label: "Wesfarmers Telehealth Code of Practice",
				link: "/code-of-practice",
			},
		],
		imageUri: "/images/logos/instant-scripts-logo-IS2-blue.svg",
	},
	{
		children: [
			{
				label: "Locations",
				link: "/pharmacy-health-hub",
			},

			{
				label: "Privacy T&C",
				link: "/phh/privacy",
			},
		],
		iconName: "IS-Pharmacy",
	},
	{
		children: [
			{
				label: "Pulse Rewards",
				link: "/pulse-rewards",
			},
			{
				label: "OnePass",
				link: "/onepass",
			},
			{
				label: "Refer a friend",
				link: "/refer-a-friend",
			}
		],
		iconName: "trophy",
		label: "Promotions",
	},
	{
		children: [
			{
				label: "FAQ",
				link: "/faq",
			},
			{
				label: "Help center",
				link: "https://help.instantscripts.com.au",
			},
			{
				label: "Contact us",
				link: "/contact-us",
			},
		],
		iconName: "help-msg",
		label: "Help",
	},
	{
		children: [
			{
				label: "Doctors",
				link: "/doctor-careers",
			},
			{
				label: "Pharmacies",
				link: "/pharmacy-registration",
			},
		],
		iconName: "steth-heart",
		label: "Work with us",
	},
];
